<template>
  <div>
    <breadcrumbs :crumbs="[]">
      <div class="folders-breadcrumbs">
        <router-link :to="{name: 'Reports Index', params: {reset: true}}">Reports</router-link>
        <i class="fa fa-angle-right"></i>
        <router-link v-if="this.report" :to="{name: 'Reports View', params: {reportid: report.id}}">{{report.name}}</router-link>
        <i class="fa fa-angle-right"></i><a>{{addOrEdit}} Summary</a>
      </div>
    </breadcrumbs>

    <div class="portlet light">
      <div class="portlet-title" v-if="report">
        <div class="caption caption-md">
          <i class="icon-globe theme-font hide"></i>
          <span class="caption-subject"><strong class="uppercase">{{addOrEdit}} Report Summary:</strong> {{report.name}}</span>
        </div>
      </div>
      <div class="portlet-body">
        <spinner v-show="loading.edit"></spinner>
        <div class="col-md-12">
          <div class="row" v-show="!loading.edit">
            <div class="col-md-6">
              <form data-vv-scope="add-summary" class="form-horizontal">
                <div class="form-group" :class="{ 'has-error': errors.has('add-summary.name') }">
                  <label for="formname">Summary Name</label>
                  <input id="formname" class="form-control"
                         placeholder="Summary Name" name="name"
                         type="text" v-validate="'required|min:1'"
                         v-model="summaryName">
                  <span v-show="errors.has('add-summary.name')"
                        class="help-block">{{ errors.first('add-summary.name') }}</span>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="form-body">
          <form-wizard @on-complete="onComplete"
                       title=""
                       subtitle=""
                       color="#d09f23"
                       @on-change="wizardTabChanged"
                       :start-index="wizardStartIndex"
          >
            <tab-content title="Filter Results" icon="fa fa-check-square-o">
              <div class="row">
                <div class="col-md-6" v-if="report">
                  <div v-for="form in report.data" class="list-group accordion">
                    <a class="accordion-toggle list-group-title collapsed"
                       data-toggle="collapse" data-parent="#criteria-accordion"
                       :href="'#collapse_f_'+form.form_id">{{ form.form_name }}<i class="fa"></i></a>
                    <div :id="'collapse_f_'+form.form_id" class="collapse">
                      <template v-for="field in form.fields">
                        <div class="list-group-item" :class="{ 'active': field == currentField }" v-if="!isSharedFormPreviewType(field.field)" @click="selectField(field)">{{field.label}}</div>
                      </template>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="currentField !== null">
                  <div class="editBox">
                    <h5>Edit: <strong>{{ currentField.label }}</strong></h5>
                  </div>
                  <div class="conditions-box">
                    <form>
                      <div class="form-body">

                        <div class="col-md-12">
                          <template v-if="currentConditions">
                            <template v-if="getFieldType(currentField.field) === 'date'">
                              <div class="form-group"
                                   v-for="(condition, idx) in currentConditions.conditions">
                                <i class="fa fa-trash pull-right"
                                   @click="removeCondition(idx)"
                                   aria-hidden="true"></i>
                                <label>Date range:</label>
                                <select class="form-control" v-model="condition.date" @change="clearVal(condition)">
                                  <option value="">Select option...</option>
                                  <option v-for="field in dateConditions" :value="field.type">{{ field.name }}</option>
                                </select>

                                <div v-if="condition.date == 'birthmonth'">
                                  <br/>
                                  <label>Month:</label>
                                  <select class="form-control" v-model="condition.value">
                                    <option value="">Select option...</option>
                                    <option v-for="n in 12" :value="n">{{ n }}</option>
                                  </select>
                                </div>

                                <template v-if="['lessthan','greaterthan','lessorequal','greaterorequal'].includes(condition.date)">
                                  <br/>
                                  <date-picker
                                      v-model="condition.value"
                                      prefix-class="xmx"
                                      placeholder="Select Date"
                                      lang="en"
                                      :format="dateFormat">
                                  </date-picker>
                                </template>

                                <template v-if="condition.date === 'between'">
                                  <br/>
                                  <date-picker
                                      v-model="condition.value"
                                      placeholder="Select Date Range"
                                      lang="en"
                                      range-separator="-"
                                      prefix-class="xmx"
                                      :range="true"
                                      :format="dateFormat">
                                  </date-picker>
                                </template>

                                <hr v-if="idx + 1 < currentConditions.conditions.length">
                              </div>
                            </template>

                            <template v-else>
                              <div class="form-group"
                                   v-for="(condition, idx) in currentConditions.conditions">
                                <i class="fa fa-trash pull-right"
                                   @click="removeCondition(idx)"
                                   aria-hidden="true"></i>
                                <label>Type:</label>
                                <select v-model="condition.type"
                                        class="form-control"
                                        @change="clearVal(condition)">

                                  <option v-for="conditionType in conditionTypes"
                                          :value="conditionType.type">
                                    {{conditionType.name}}
                                  </option>
                                  <option v-if="!['_creator_id','_editor_id','_casemgr_account','programs'].includes(getFieldType(currentField.field))"
                                          v-for="conditionType in emptyFilledConditionTypes"
                                          :value="conditionType.type">
                                    {{conditionType.name}}
                                  </option>
                                  <option v-if="!['_creator_id','_editor_id','_casemgr_account','programs'].includes(getFieldType(currentField.field))"
                                          v-for="conditionType in numericConditionTypes"
                                          :value="conditionType.type">
                                    {{conditionType.name}}
                                  </option>
                                </select>
                                <br>
                                <div v-if="!['unduplicated','between','isempty','isfilled','recent'].includes(condition.type)">
                                  <label>{{
                                    currentField.field.substr(0,
                                    currentField.field.indexOf('-'))
                                    == 'rating' ? 'Value: ' :
                                    'Label: ' }}</label>
                                  <input type="text" value=""
                                         class="form-control"
                                         v-model="condition.value">
                                  <br>
                                </div>

                                <div v-if="['between'].includes(condition.type)">
                                  <label>From</label>
                                  <input type="text"
                                         v-model="condition.value[0]"
                                         class="form-control">
                                  <br/>
                                  <label>To</label>
                                  <input type="text"
                                         v-model="condition.value[1]"
                                         class="form-control">
                                </div>
                                <hr>
                              </div>
                              <div class="form-group"
                                   v-if="currentConditions.conditions.length > 1">
                                <label>
                                  If
                                  <select v-model="currentConditions.all">
                                    <option :value="false">Any
                                    </option>
                                    <option :value="true">All
                                    </option>
                                  </select>
                                  the rules are matched.
                                </label>
                              </div>

                            </template>
                          </template>
                          <div class="form-group margin-bottom-0"
                               v-if="!['_manager_id','_secondary_manager_id'].includes(getFieldType(currentField.field))">
                            <button class="btn green" @click.prevent="addNewCondition()">+ Add New Condition</button>
                          </div>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </form>
                  </div>
                </div>
              </div>
            </tab-content>

            <tab-content title="Add Columns" icon="fa fa-columns" :before-change="onAddColumnsComplete">

              <div class="row">
                <div class="col-md-6" v-if="report">
                  <div v-for="form in report.data" class="list-group accordion">
                    <a class="accordion-toggle list-group-title collapsed"
                       data-toggle="collapse" data-parent="#criteria-accordion"
                       :href="'#form-columns-collapse'+form.form_id">{{
                      form.form_name }}<i class="fa"></i></a>
                    <div :id="'form-columns-collapse'+form.form_id"
                         class="collapse">
                      <div v-for="field in form.fields"
                           v-if="!inColumns(field) && !isSharedFormPreviewType(field.field)"
                           class="list-group-item"
                           @click="addColumn(field)">
                        {{ field.label }}
                      </div>
                      <div v-if="!inColumns({'field':'total','form_id':'_'})"
                           class="list-group-item"
                           @click="addColumn({'field':'total','form_id':'_','label':'Total Count'})">
                        Total Count
                      </div>
                      <div v-if="!inColumns({'field':'unduplicated','form_id':'_'})"
                           class="list-group-item"
                           @click="addColumn({'field':'unduplicated','form_id':'_','label':'Unduplicated Count'})">
                        Unduplicated Count
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <template class="list-group">
                    <span class="list-group-title">Columns in Summary</span>
                    <draggable :list="columns" tag="ul" class="list-group">
                      <li v-for="column in columns" :key="column.order"
                          class="list-group-item"
                          @click="removeSelectedColumn(column)">{{ column.label }}
                      </li>
                    </draggable>
                  </template>
                </div>
              </div>

            </tab-content>
            <tab-content title="Setup Data"
                         icon="fa fa-cogs"
                         :before-change="onDataSetupComplete">

              <div class="row">
                <div class="col-md-6" v-if="report">
                  <template class="list-group">
                    <span class="list-group-title">Columns in Summary</span>
                    <draggable :list="columns" tag="ul" class="list-group">
                      <li v-for="column in columns"
                          :class="{'active': currentColumn && column.field === currentColumn.field}"
                          class="list-group-item"
                          :key="column.order"
                          @click="selectColumnForSetup(column)">{{ column.label }}
                      </li>
                    </draggable>
                  </template>
                </div>

                <div class="col-md-6">

                  <div class="data-setup-box form-group">
                    <template v-if="currentColumn">

                      <input type="text" class="form-control" disabled="true" :value="currentColumn.label">

                      <template v-if="!(['__total','__unduplicated'].includes(currentColumn.field))">
                        <br>
                        <div class="margin-bottom-10">
                          <toggle-button :class="'margin-bottom-0'" :labels="true"
                                         :value="isBaseline()" :sync="true"
                                         @change="onBaselineFieldChange(currentColumn, $event)"/>
                          <span>Set as baseline field</span>
                        </div>

                        <div v-if="isBaseline() && multipleValuesFields.some(el => currentColumn.field.includes(el))" class="margin-bottom-10">
                          <toggle-button :class="'margin-bottom-0'" :labels="true"
                                         :value="showAllValuesForField()" :sync="true"
                                         @change="onShowAllValuesForFieldChange(currentColumn, $event)"/>
                          <span>Include all possible values</span>
                        </div>
                        <div v-if="isBaseline()">
                          <toggle-button :class="'margin-bottom-0'" :labels="true"
                                         :value="countNullValuesForField()" :sync="true"
                                         @change="onCountNullValuesForFieldChange(currentColumn, $event)"/>
                          <span>Count null values</span>
                        </div>

                        <div v-if="!isBaseline()">
                          <hr>
                          <label for="select-col-value">Values function</label>
                          <select
                              id="select-col-value"
                              class="form-control"
                              v-model="currentColumn.values_function">
                            <option value="concat">None</option>
                            <option value="sum">Sum</option>
                            <option value="avg">Average</option>
                          </select>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </tab-content>

            <tab-content title="Add Chart" icon="fa fa-bar-chart">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <div class="data-setup-box">
                    <span>Add Chart</span>
                    <toggle-button :class="'margin-bottom-0'" :labels="true"
                                   :value="hasChart" :sync="true"
                                   @change="onHasChartChange"

                    />
                    <hr>

                    <form v-if="hasChart">
                      <div class="form-group">
                        <label for="chart-title">Chart Title</label>
                        <input id="chart-title" class="form-control"
                               placeholder="Chart Title" name="chart-title"
                               type="text" v-validate="'required'"
                               v-model="chart.title">
                      </div>
                      <div class="form-group">
                        <label for="chart-type">Chart Types</label>
                        <select
                            id="chart-type"
                            class="form-control"
                            v-model="chart.type">
                          <option value="bar-horizontal">Bar Chart (Horizontal)</option>
                          <option value="bar-vertical">Bar Chart (Vertical)</option>
                          <option value="line">Line Chart</option>
                          <option value="pie">Pie Chart</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="chart-type">Labels (Y axis)</label>
                        <select
                            id="y-axis"
                            class="form-control"
                            v-model="chart.labels">
                          <option v-for="column in columns" :value="column.field">{{column.label}}</option>
                        </select>
                      </div>
                      <div v-if="chart.type !== 'pie'" class="form-group">
                        <label for="chart-label-y">Label for Y axis</label>
                        <input id="chart-label-y" class="form-control"
                               placeholder="Label for Y axis" name="chart-y-axis-label"
                               type="text"
                               v-model="chart.labelY">
                      </div>
                      <div v-if="chart.type !== 'pie'" class="form-group">
                        <label for="chart-label-x">Label for X axis</label>
                        <input id="chart-label-x" class="form-control"
                               placeholder="Label for X axis" name="chart-x-axis-label"
                               type="text"
                               v-model="chart.labelX">
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-6">
                  <div v-if="hasChart" class="data-setup-box">
                    <p>Values</p>
                    <div v-for="column, idx in columns" class="">
                      <label class="mt-checkbox mt-checkbox-outline">
                        {{ column.label }}
                        <input type="checkbox" :value="column.field" v-model="chart.dataSeries"/>
                        <span></span>
                      </label>
                      <hr class="chart-color" :style="{background: '#' +chartColors[idx % chartColors.length]}">
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </tab-content>
          </form-wizard>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner';
  import DatePicker from 'vue2-datepicker';
  import {mapActions, mapGetters} from 'vuex';
  import _ from 'lodash';
  import ReportTable from "./ReportTable";
  import VueSelect from 'vue-select'
  import draggable from 'vuedraggable';
  import {ERROR, HTTP} from "../../http-common";
  import defaultChartData from "./defaultChartData";
  import fieldTypeUtils from "../../mixins/fieldTypeUtils";
  import reportCommons from "../../mixins/reportCommons";

  export default {
    data() {
      return {
        addOrEdit: 'Add',
        summaryName: null,
        loading: false,
        conditions: [],
        columns: [],
        currentColumn: null,
        baseLineField: null,
        settings: {},
        report: null,
        summaryId: null,

        select: [],

        currentField: null,

        selectedForms: [],
        selectedFields: [],
        multipleValuesFields: ['checkbox-group', 'radio-group', 'checkbox' , 'select', 'rating'],
        dateFormat: 'MM/DD/YYYY',

        addChartToggle: false,
        hasChart: false,
        chart: {},
        wizardStartIndex: 0,

        tmpResults: [],
        tmpColumns: [],
      }
    },
    mixins: [
      fieldTypeUtils,
      reportCommons
    ],
    components: {
      DatePicker,
      ReportTable,
      Breadcrumbs,
      Spinner,
      VueSelect,
      draggable,
    },
    inject: {
      $validator: '$validator'
    },

    created() {
      this.fetchReport(this.$route.params.reportid);

      this.summaryId = this.$route.params.summaryId;
      this.chart = JSON.parse(JSON.stringify(defaultChartData));

      if (this.summaryId) {
        this.addOrEdit = 'Edit';
        HTTP.post('report-summary/edit', {
          'summary_id': this.summaryId
        }).then(response => {
          this.columns = response.data.data.columns;

          this.conditions = response.data.data.conditions.map(condition => {
            // convert date in isoformat to actual dates
            if (this.getFieldType(condition.field) === 'date') {
              condition.conditions = condition.conditions.map(c => {
                if (c.date) {
                  if (c.date === 'between') {
                    c.value = [new Date(c.value[0]), new Date(c.value[1])];
                  } else {
                    c.value = new Date(c.value);
                  }
                }
                return c;
              })
            }
            return condition;
          });

          this.summaryName = response.data.data.name;
          this.baseLineField = response.data.data.baseline_field;
          this.hasChart = response.data.data.has_chart;

          if (response.data.data.has_chart) {
            this.chart = {
              'title': response.data.data.chart_data.title,
              'type': response.data.data.chart_data.type,
              'labelY': response.data.data.chart_data.y_axis_label,
              'labelX': response.data.data.chart_data.x_axis_label,
              'labels': response.data.data.chart_data.labels,
              'dataSeries': response.data.data.chart_data.data_series
            };
          }

        }).catch(err => {
          console.log(err);
        })
      }
      if (this.$route.params.summaryId) {
        if (this.$route.hash === '#chart') {
          this.wizardStartIndex = 3;
        }
      }
    },

    mounted() {
      if (!this.$route.params.reportid) {
        this.$notify({type: 'error', text: 'Wrong report.'});
        this.$route.push({'name': 'Reports Index'})
      }

      this.dateFormat = this.user.date_format;
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        formFields: 'getFieldsReportInOrder',
        userAccounts: 'getUserAccounts',
        account: 'account',
        organization: 'getOrganization',
        chartColors: 'helper/getChartColors'
      }),

      currentConditions() {
        return this.conditions.find(item => item.field === this.currentField.form_id + '_' + this.currentField.field);
      },
    },
    methods: {
      ...mapActions({
        loadFields: 'GET_FORMS_FIELDS_ACTION',
        addReport: 'ADD_REPORT_ACTION',
        editReport: 'EDIT_REPORT_ACTION',
        getAccount: 'GET_ACCOUNT_ACTION'
      }),
      fetchReport(id) {
        HTTP.get('/reports-summary/get-report/' + id).then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.report = response.data.data;
          }
        }).catch(err => {
          console.log(err);
          this.$notify({'type': 'error', 'text': err.data.message});
        }).finally(() => {

        });
      },

      clearVal(el, data) {
        if (el.type === 'between') {
          el.value = ['', ''];
          return;
        }

        if (el.hasOwnProperty('date') && ['lessthan', 'lessorequal', 'greaterthan', 'greaterorequal'].includes(el.date)) {
          if (!Array.isArray(el.value)) {
            el.value = ['', ''];
          }
          return;
        }

        if (!['unduplicated', 'between', 'isempty', 'isfilled'].includes(el.type)) {
          el.value = '';
        }

        if (el.value != null) {
          el.value = '';
        }
      },
      removeSelectedColumn(column) {
        let idx = this.columns.findIndex(item => {
          return item.field === column.field
        });

        this.columns.splice(idx, 1);
        this.resetChartDataSeries();
      },
      wizardTabChanged(prevIndex, nextIndex) {

      },
      getFieldType(name) {
        if (['_creation_date', '_edition_date'].includes(name)) {
          return 'date'
        }

        if (name.includes('_')) {
          name = name.split('_')[1];
        }

        const field = name.split('-');
        return field[0]
      },
      async onComplete() {
        let validateResult = await this.$validator.validateAll('add-summary');

        if (!validateResult) {
          return;
        }

        if (this.summaryId) {
          HTTP.post('report-summary/update', {
            'summary_id': this.summaryId,
            'name': this.summaryName,
            'conditions': this.conditions,
            'columns': this.columns,
            'baseline_field': this.baseLineField,
            'report_id': this.report.id,
            'has_chart': this.hasChart,
            'chart_data': {
              'title': this.chart.title,
              'type': this.chart.type,
              'label_y': this.chart.labelY,
              'label_x': this.chart.labelX,
              'labels': this.chart.labels,
              'data_series': this.chart.dataSeries
            }
          }).then(response => {
            this.$router.push({name: 'Reports View', params: {reportid: this.report.id}, hash: '#summary'})
          }).catch(err => {
            this.$notify({text: 'Something went wrong while updating report summary.', type: 'error'})
          });
          return;
        }

        HTTP.post('reports-summary/create', {
          'name': this.summaryName,
          'conditions': this.conditions,
          'columns': this.columns,
          'baseline_field': this.baseLineField,
          'report_id': this.report.id,
          'has_chart': this.hasChart,
          'chart_data': {
            'title': this.chart.title,
            'type': this.chart.type,
            'label_y': this.chart.labelY,
            'label_x': this.chart.labelX,
            'labels': this.chart.labels,
            'data_series': this.chart.dataSeries
          }
        }).then(response => {
          if (response.data.status === 'success') {
            this.$router.push({name: 'Reports View', params: {reportid: this.report.id}, hash: '#summary'})
          }
        }).catch(err => {
          this.$notify({text: 'Something went wrong while creating report summary.', type: 'error'})
        })
      },
      addColumn(field) {
        if (!this.inColumns(field)) {
          this.columns.push({
            field: field.form_id + '_' + field.field,
            label: field.label,
            id: field.form_id,
            values_function: 'concat'
          })
          this.resetChartDataSeries();
        }
      },
      inColumns(field) {
        return (this.columns.find(col => {
          return col.field === field.form_id + '_' + field.field;
        }) !== undefined)
      },

      selectColumnForSetup(column) {
        this.currentColumn = column;
      },

      onBaselineFieldChange(column, event) {
        this.baseLineField = event.value ? column.field : null;
      },

      isBaseline() {
        if (this.baseLineField === null) {
          return false;
        }
        return this.currentColumn.field === this.baseLineField;
      },

      showAllValuesForField() {
        if (this.currentColumn.hasOwnProperty('show_all_values')) {
          return this.currentColumn.show_all_values;
        }
        return true;
      },

      onShowAllValuesForFieldChange(column, event) {
        this.$set(this.currentColumn, 'show_all_values', event.value);
      },

      countNullValuesForField() {
        if (this.currentColumn.hasOwnProperty('count_null_values')) {
          return this.currentColumn.count_null_values;
        }
        return false;
      },

      onCountNullValuesForFieldChange(column, event) {
        this.$set(this.currentColumn, 'count_null_values', event.value);
      },

      addNewCondition() {
        let emptyCondition = {
          'type': '',
          'value': ''
        }

        if (this.getFieldType(this.currentField.field) === 'date') {
          emptyCondition.date = '';
        }

        let fieldConditions = this.conditions.find(item => item.field == this.currentField.form_id + '_' + this.currentField.field);

        if (fieldConditions) {
          fieldConditions.conditions.push(emptyCondition);
          return;
        }

        this.conditions.push({
          'field': this.currentField.form_id + '_' + this.currentField.field,
          'conditions': [emptyCondition],
          'all': true
        });
      },
      selectField(data) {
        this.currentField = data;
      },
      removeCondition(idx) {
        this.currentConditions.conditions.splice(idx, 1);
      },
      onAddColumnsComplete() {
        return !!this.columns.length;
      },
      onDataSetupComplete() {
        return true;
      },
      onHasChartChange(ev) {
        this.hasChart = ev.value;
      },
      resetChartDataSeries() {
        this.chart.dataSeries = JSON.parse(JSON.stringify(defaultChartData.dataSeries));
      },
    },
  }
</script>

<style scoped lang="scss">
  .ms-container {
    width: 100%;
  }

  .ms-container .ms-list {
    height: 400px;
  }

  .conditions-box {
    border: 1px solid rgba(0, 0, 0, .2);
    padding-top: 1em;
    padding-bottom: 1em;
    /*padding: 20px;*/
  }

  .accordion .list-group-item {
    padding: 10px 15px;
    border-color: #ddd;
  }

  .list-group span, .list-group-title {
    width: 100%;
    display: block;
    background: #d09f24;
    color: white;
    font-weight: 600;
    padding: 10px 15px;
  }

  .list-group-title i {
    float: right;
    margin-top: 2px;
  }

  .list-group-item:hover {
    cursor: pointer;
  }

  .list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
    background-color: #d09f24;
    border-color: #d09f24
  }

  .sortable-chosen.sortable-ghost {
    background: #ddd;
  }

  .margin-bottom-0 {
    margin-bottom: 0;
  }

  .data-setup-box {
    border: 1px solid rgba(0, 0, 0, .2);
    padding: 20px;
  }

  .chart-color {
    display: inline-block;
    width: 50px;
    margin: 0 5px 5px 5px;
    border: none;
    height: 3px;
  }

</style>



// WEBPACK FOOTER //
// ReportEditSummary.vue?5e47e970